import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./languages/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { FlagsmithProvider } from "flagsmith-react";
import { IS_CONCULAR_ONE } from "utils";
import posthog from "posthog-js";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";

if (
  ["prod", "staging", "dev"].includes(import.meta.env.VITE_ENV || "") &&
  import.meta.env.VITE_SENTRY_DSN
) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV,
    integrations: [],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,
  });
}

// Set the title based on the environment variable
document.title = IS_CONCULAR_ONE
  ? "Concular One - Akademie | Netzwerk | Tools"
  : "Circular Platform by Concular";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

//Set favicon based on the environment variable
document.addEventListener("DOMContentLoaded", () => {
  const favicon = document.getElementById("favicon") as HTMLAnchorElement;
  if (favicon) {
    favicon.href = IS_CONCULAR_ONE ? "/one_favicon.ico" : "/favicon.ico";
  }
});

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN, {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: "2026-01-30",
});

function getFlagsmithEnvId() {
  return import.meta.env.VITE_FLAGSMITH_KEY;
}

root.render(
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <FlagsmithProvider environmentId={getFlagsmithEnvId()}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FlagsmithProvider>
    </PostHogErrorBoundary>
  </PostHogProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
